export default __webpack_public_path__ + "static/media/invoice.e9a56839.svg";